import { AuthPlugin, persistSessionCookie, SessionManager } from "@xlabmedical/medic-web-framework";
import { ServerAPI } from "@xlabmedical/medic-api";
import { useSTLLibraryStore } from "@xlabmedical/medic-web-framework";
import { WebRgWebsocketManager } from "@/util/WebRgWebsocketManager";

export async function setupSession(auth: AuthPlugin, sessionManager: SessionManager, api: ServerAPI, wsManager: WebRgWebsocketManager) {
    const sessionId = auth.getSessionId();
    sessionManager.applySession(sessionId);
    api.setSessionId(sessionId);
    persistSessionCookie(sessionId);
    wsManager.connect(sessionId);

    const stlStore = useSTLLibraryStore();
    stlStore.loadSTLLibrary();
}
